/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import { MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { translate, translateHelperTextIfExists } from "@/src/services/translations/translations";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { requiredValidator } from "@/src/services/validationRules";
import { getFormDefinitions } from "@/src/services/formDefinitions/formDefinitions";

type SingleSelectFieldConfiguredProps = {
  caseData: any;
  fieldPath: string;
  required?: boolean | undefined;
};
export default function SingleSelectFieldConfigured(
  {
    caseData,
    fieldPath,
    required,
  }: SingleSelectFieldConfiguredProps) {

  const helperText = translateHelperTextIfExists(caseData, fieldPath);
    const question = translate(`${caseData.name}.${fieldPath}.question`, caseData);
    const label = translate(`${caseData.name}.${fieldPath}.label`, caseData);
  const validators = [];
  if (required) {
    validators.push(requiredValidator());
  }
  const menuItems = getFormDefinitions(caseData, fieldPath).options;

  return (
    <>
      <Grid size={12}>
        <FormLegend>{question}</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorSelectField label={label} name={fieldPath} validators={validators} helperText={helperText}>
          {menuItems.map((item: string, index: number) => (
            <MenuItem key={index} value={item}>
              {translate(`${caseData.name}.${fieldPath}.options.${item}.label`, caseData)}
            </MenuItem>
          ))}
        </ValidatorSelectField>
      </Grid>
    </>
  );
}
